module.exports = __webpack_public_path__ + "static/media/env.9b62c738.hdr";